
enum bugsBatman {
    Idle = "wb-mash-bugs-batman-idle.png",
    Launch = "wb-mash-bugs-batman-launch.png",
    Fall = "wb-mash-bugs-batman-fall.png",
    Batarang = "wb-mash-bugs-batman-batarang.png",
    Fly = "wb-mash-bugs-batman-fly.png",
    Firecracker = "wb-mash-bugs-batman-firecracker.png",
    RollerSkates = "wb-mash-bugs-batman-rollerskates.png",
    NegHit = "wb-mash-bugs-batman-neghit.png",
    Crash = "wb-mash-bugs-batman-crash.png",
    SmashFail = "wb-mash-bugs-batman-smashfail.png",
    SmashThroughWall = "wb-mash-bugs-batman-smashthroughwall.png",
}

enum bugsFredFlinstone {
    Idle = "wb-mash-bugs-flinstonesfred-idle.png",
    Launch = "wb-mash-bugs-flinstonesfred-launch.png",
    Fall = "wb-mash-bugs-flinstonesfred-fall.png",
    Batarang = "wb-mash-bugs-flinstonesfred-powerup.png",
    Fly = "wb-mash-bugs-flinstonesfred-fly.png",
    Firecracker = "wb-mash-bugs-flinstonesfred-firecracker.png",
    RollerSkates = "wb-mash-bugs-flinstonesfred-rollerskates.png",
    NegHit = "wb-mash-bugs-flinstonesfred-neghit.png",
    Crash = "wb-mash-bugs-flinstonesfred-crash.png",
    SmashFail = "wb-mash-bugs-flinstonesfred-smashfail.png",
    SmashThroughWall = "wb-mash-bugs-flinstonesfred-smashthroughwall.png",
}

enum bugsFredScooby {
    Idle = "wb-mash-bugs-scoobfreddie-idle.png",
    Launch = "wb-mash-bugs-scoobfreddie-launch.png",
    Fall = "wb-mash-bugs-scoobfreddie-fall.png",
    Batarang = "wb-mash-bugs-scoobfreddie-scoobysnackpowerup.png",
    Fly = "wb-mash-bugs-scoobfreddie-fly.png",
    Firecracker = "wb-mash-bugs-scoobfreddie-firecracker.png",
    RollerSkates = "wb-mash-bugs-scoobfreddie-rollerskates.png",
    NegHit = "wb-mash-bugs-scoobfreddie-neghit.png",
    Crash = "wb-mash-bugs-scoobfreddie-crash.png",
    SmashFail = "wb-mash-bugs-scoobfreddie-smashfail.png",
    SmashThroughWall = "wb-mash-bugs-scoobfreddie-smashthroughwall.png",
}

enum tweetyBatman {
    Idle = "wb-mash-tweety-batman-idle.png",
    Launch = "wb-mash-tweety-batman-launch.png",
    Fall = "wb-mash-tweety-batman-fall.png",
    Batarang = "wb-mash-tweety-batman-batarang.png",
    Fly = "wb-mash-tweety-batman-fly.png",
    Firecracker = "wb-mash-tweety-batman-firecracker.png",
    RollerSkates = "wb-mash-tweety-batman-rollerskates.png",
    NegHit = "wb-mash-tweety-batman-neghit.png",
    Crash = "wb-mash-tweety-batman-crash.png",
    SmashFail = "wb-mash-tweety-batman-smashfail.png",
    SmashThroughWall = "wb-mash-tweety-batman-smashthroughwall.png",
}

enum daffySuperman {
    Idle = "wb-mash-daffy-superman-idle.png",
    Launch = "wb-mash-daffy-superman-launch.png",
    Fall = "wb-mash-daffy-superman-fall.png",
    Batarang = "wb-mash-daffy-superman-downwardsmash.png",
    Fly = "wb-mash-daffy-superman-fly.png",
    Firecracker = "wb-mash-daffy-superman-firecracker.png",
    RollerSkates = "wb-mash-daffy-superman-rollerskates.png",
    NegHit = "wb-mash-daffy-superman-neghit.png",
    Crash = "wb-mash-daffy-superman-crash.png",
    SmashFail = "wb-mash-daffy-superman-smashfail.png",
    SmashThroughWall = "wb-mash-daffy-superman-smashthroughwall.png",
}

enum daffyBatman {
    Idle = "wb-mash-daffy-batman-idle.png",
    Launch = "wb-mash-daffy-batman-launch.png",
    Fall = "wb-mash-daffy-batman-fall.png",
    Batarang = "wb-mash-daffy-batman-batarang.png",
    Fly = "wb-mash-daffy-batman-fly.png",
    Firecracker = "wb-mash-daffy-firecracker.png",
    RollerSkates = "wb-mash-daffy-rollerskates.png",
    NegHit = "wb-mash-daffy-batman-neghit.png",
    Crash = "wb-mash-daffy-crash.png",
    SmashFail = "wb-mash-daffy-smashfaill.png",
    SmashThroughWall = "wb-mash-daffy-smashthroughwall.png",
}

enum tweetySuperman {
    Idle = "wb-mash-tweety-superman-idle.png",
    Launch = "wb-mash-tweety-superman-launch.png",
    Fall = "wb-mash-tweety-superman-fall.png",
    Batarang = "wb-mash-tweety-superman-powerup.png",
    Fly = "wb-mash-tweety-superman-fly.png",
    Firecracker = "wb-mash-tweety-superman-firecracker.png",
    RollerSkates = "wb-mash-tweety-superman-rollerskates.png",
    NegHit = "wb-mash-tweety-superman-neghit.png",
    Crash = "wb-mash-tweety-superman-crash.png",
    SmashFail = "wb-mash-tweety-superman-smashfail.png",
    SmashThroughWall = "wb-mash-tweety-superman-smashthroughwall.png",
}

enum lolaWonderwoman {
    Idle = "wb-mash-lola-wonderwoman-idle.png",
    Launch = "wb-mash-lola-wonderwoman-launch.png",
    Fall = "wb-mash-lola-wonderwoman-fall.png",
    Batarang = "wb-mash-lola-wonderwoman-powerup.png",
    Fly = "wb-mash-lola-wonderwoman-fly.png",
    Firecracker = "wb-mash-lola-wonderwoman-firecracker.png",
    RollerSkates = "wb-mash-lola-wonderwoman-rollerskates.png",
    NegHit = "wb-mash-lola-wonderwoman-neghit.png",
    Crash = "wb-mash-lola-wonderwoman-crash.png",
    SmashFail = "wb-mash-lola-wonderwoman-smashfail.png",
    SmashThroughWall = "wb-mash-lola-wonderwoman-smashthroughwall.png",
}

enum lolaDaphne {
    Idle = "wb-mash-lola-daphne-idle.png",
    Launch = "wb-mash-lola-daphne-launch.png",
    Fall = "wb-mash-lola-daphne-fall.png",
    Batarang = "wb-mash-lola-daphne-powerup.png",
    Fly = "wb-mash-lola-daphne-fly.png",
    Firecracker = "wb-mash-lola-daphne-firecracker.png",
    RollerSkates = "wb-mash-lola-daphne-rollerskates.png",
    NegHit = "wb-mash-lola-daphne-neghit.png",
    Crash = "wb-mash-lola-daphne-crash.png",
    SmashFail = "wb-mash-lola-daphne-smashfail.png",
    SmashThroughWall = "wb-mash-lola-daphne-smashthroughwall.png",
}

enum lolaFlintstones {
    Idle = "wb-mash-lola-wilma-idle.png",
    Launch = "wb-mash-lola-wilma-launch.png",
    Fall = "wb-mash-lola-wilma-fall.png",
    Batarang = "wb-mash-lola-wilma-powerup.png",
    Fly = "wb-mash-lola-wilma-fly.png",
    Firecracker = "wb-mash-lola-wilma-firecracker.png",
    RollerSkates = "wb-mash-lola-wilma-rollerskates.png",
    NegHit = "wb-mash-lola-wilma-neghit.png",
    Crash = "wb-mash-lola-wilma-crash.png",
    SmashFail = "wb-mash-lola-wilma-smashfail.png",
    SmashThroughWall = "wb-mash-lola-wilma-smashthroughwall.png",
}

export default class CharacterAtlas {
    static characters: {[key: string]: any} = {
        bugsBatman: bugsBatman,
        bugsFredFlinstone: bugsFredFlinstone,
        bugsFredScooby: bugsFredScooby,
        daffyBatman: daffyBatman,
        daffySuperman: daffySuperman,
        tweetyBatman: tweetyBatman,
        tweetySuperman: tweetySuperman,
        lolaWonderwoman: lolaWonderwoman,
        lolaDaphne: lolaDaphne,
        lolaFlintstones: lolaFlintstones,
    }
}



